import { usePlatformStore, useMobileMenu } from "@platform/store";
import { DashboardHeader } from "./DashboardHeader";

type Props = {
  // Pass navigation component as children
  children: React.ReactNode;
};

export function DashboardHeaderContainer({ children }: Props) {
  const {
    isOpen: isMobileMenuOpen,
    open: openMobileMenu,
    close: closeMobileMenu,
  } = useMobileMenu();

  const isChatDisabled = usePlatformStore(
    (s) => s.featureFlags.isChatDisabled
  );

  return (
    <DashboardHeader
      isMobileMenuOpen={isMobileMenuOpen ?? false}
      openMobileMenu={openMobileMenu}
      closeMobileMenu={closeMobileMenu}
      isChatDisabled={isChatDisabled}
    >
      {children}
    </DashboardHeader>
  );
}

export default DashboardHeaderContainer;


